export const categoryTopicStatus = [
    { value: false, label: "Inactive" },
    { value: true, label: "Active" },
  ]